<template>
	<div>
		<div class="head">
			<div class="head_img">
				<img src="../assets/boloni.jpg" />
				<ul>
					<li><a href="#" @click="ten()">相关资料</a></li>
					<li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
					<li><a href="#" @click="eight()">检测工具及设备</a></li>
					<li><a href="#" @click="seven()">主要生产设备</a></li>
					<li><a href="#" @click="twelve()">竞品客户信息</a></li>
					<li><a href="#" @click="six()">销售前五名客户</a></li>
					<li><a href="#" @click="five()">付款信息</a></li>
					<li><a href="#" @click="four()">人员信息</a></li>
					<li><a href="#" @click="eleven()">供货产品及产能</a></li>
					<li><a href="#" @click="three()">经营情况</a></li>
					<li><a href="#" @click="two()">基本信息</a></li>
					<li><a href="#" @click="one()">供货类型</a></li>
				</ul>
			</div>
		</div>

		<div class="main">
			<div class="main_title">
				<span>销售前五名客户</span>
			</div>
			<div class="item">
				<span class="item_title">请完善以下信息</span>
			</div>
			<div class="main_info">
				<div class="payment_info el-table">
					<!--       <h3>销售前五名客户（必填评分项，没有请填写无）</h3> -->
					<el-table :data="PeRateFrom" border>
						<el-table-column label="客户名称" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.cust_name"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="客户所在行业" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.cust_industry"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="主要销售产品" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.cust_product"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="合作金额(万元)" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.cust_prop"
									oninput="value=value.replace(/[^\d]/g,'')">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column label="合作金额占比(%)" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.cust_co_rate"
									oninput="value=value.replace(/[^\d]/g,'')">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column label="keyId" v-if="false">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.keyid"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button @click="handleDelete(scope.$index,scope.row.keyid)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!--
          <el-button type="success"  @click="addLine">新增行</el-button>
          <el-button type="success" icon="el-icon-check"  @click="addPeRaTe()">保存</el-button>
          <el-button 上传 class="file" icon="el-icon-arrow-left" @click="openPayment_info()" type="primary" >上一步</el-button>
          <el-button 上传 class="file" @click="nextMain()" type="primary" >下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->

				</div>
				<div class="payment_info_button">
					<button type="button" @click="addLine"><span>新增行</span></button>
					<button type="button" @click="openPayment_info()"><span>上一步</span></button>
					<button type="button" style="background-color: #27eaff"
						@click="addPeRaTe()"><span>保存</span></button>
					<button type="button" @click="nextMain()"><span>下一步</span></button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getGys,
		addPeRaTe,
		delPeRaTe,
		getPeRaTe
	} from '../api/LoginApi'
	import {
		goBack
	} from '../utils/Transformation'
	import {
		messageError,
		messageSuCcEss
	} from '../utils/message'

	export default {
		name: 'GysCooPeRate',
		data() {
			return {
				PeRateFrom: [{
					gys_no: localStorage.getItem('userName'),
					cust_name: '',
					cust_industry: '',
					cust_product: '',
					cust_prop: '',
					keyid: 0,
					show: true
				}]
			}
		},
		created() {
			this.getPeRaTe()
		},
		mounted() {
			// 页面刷新时清除localStorage
			window.onbeforeunload = function(e) {
				let storage = window.localStorage
				storage.clear()
			}
			// localStorage不存在loginguid则跳到登录页面
			if (!localStorage.getItem('loginguid')) {
				const vm = this
				vm.$router.push({
					path: '/Login'
				})
			}
			// 不允许使用页面返回按钮
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL)
				window.addEventListener('popstate', goBack, false)
			}
		},
		destroyed() {
			window.removeEventListener('popstate', goBack, false)
		},
		methods: {
			 // 给表头加必填符号*
			addRedStar(h, { column }) {
				return [
					h("span", { style: "color: red" }, "*"),
					h("span", " " + column.label),
				];
			},
			// 查询数据
			getPeRaTe() {
				getPeRaTe(localStorage.getItem('userName')).then(res => {
					if (res.length > 0) {
						this.PeRateFrom = res
						// console.log('销售前五名客户', res)
					}
					//获取单据状态
					getGys(localStorage.getItem('userName')).then(res => {
						if (res) {
							this.PeRateFrom.bill_status = res.bill_status;
						}
					});
				})
			},
			// 上一个页面
			openPayment_info() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			// 下一个页面
			nextMain() {
				if (this.PeRateFrom.bill_status != '已审核') { 
					//保存数据
					this.addPeRaTe();
					const vm = this;

					if(this.PeRateFrom.length > 0){
						for(var i = 0; i < this.PeRateFrom.length; i++){
							var item = this.PeRateFrom[i];
							if (item.cust_name){
								if (!item.cust_industry){
									return messageError('第'+(i+1)+'行[客户所属行业]不能为空!');
								}
								if (!item.cust_product){
									return messageError('第'+(i+1)+'行[主要销售产品]不能为空!');
								}
								if (!item.cust_prop){
									return messageError('第'+(i+1)+'行[合作金额]不能为空!');
								}
								if (!item.cust_co_rate){
									return messageError('第'+(i+1)+'行[合作金额占比]不能为空!');
								}
							}
						}
					}
				}
				const vm = this;
				vm.$router.push({
					path: '/CompetitorcustInfo'
				})
			},
			one() {
				const vm = this
				vm.$router.push({
					path: '/GysBasic'
				})
			},
			two() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			three() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			four() {
				const vm = this
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			five() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			six() {
				const vm = this
				vm.$router.push({
					path: '/GysCooPeRate'
				})
			},
			seven() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			eight() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			nine() {
				const vm = this
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			ten() {
				const vm = this
				vm.$router.push({
					path: '/GysMate'
				})
			},
			eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity'
				})
			},
			twelve() {
				const vm = this
				vm.$router.push({
					path: '/CompetitorcustInfo'
				})
			},
			// 保存数据
			addPeRaTe: function() {
				if (this.PeRateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
              
				if(this.PeRateFrom.length > 0){
						for(var i = 0; i < this.PeRateFrom.length; i++){
							var item = this.PeRateFrom[i];
							if (item.cust_name){
								if (!item.cust_industry){
									return messageError('第'+(i+1)+'行[客户所属行业]不能为空!');
								}
								if (!item.cust_product){
									return messageError('第'+(i+1)+'行[主要销售产品]不能为空!');
								}
								if (!item.cust_prop){
									return messageError('第'+(i+1)+'行[合作金额]不能为空!');
								}
								if (!item.cust_co_rate){
									return messageError('第'+(i+1)+'行[合作金额占比]不能为空!');
								}
							}
						}
				}

				addPeRaTe(this.PeRateFrom, localStorage.getItem('userName')).then(res => {
					if (res.code === 200) {
						return messageSuCcEss(res.msg)
					} else {
						return messageError(res.msg)
					}
				})
			},
			// 删除行，删除数据
			handleDelete: function(index, keyId) { // 删除行数
				if (this.PeRateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				if (keyId) {
					delPeRaTe(keyId).then(res => {
						if (res.code === 200) {
							return messageSuCcEss(res.msg)
						} else {
							return messageError(res.msg)
						}
					})
				}
				this.PeRateFrom.splice(index, 1)
			},
			// 新增行
			addLine: function() { 
				if (this.PeRateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				let RateValue = {
					gys_no: localStorage.getItem('userName'),
					cust_name: '',
					cust_industry: '',
					cust_product: '',
					cust_prop: '',
					keyid: 0,
					show: true
				}
				this.PeRateFrom.push(RateValue)
			}
		}
	}
</script>



<style scoped>
	@import "../css/Main.css";
	.required-star::before {
		content: "*";
		color: red;
		margin-right: 4px; /* 根据需要调整间距 */
	}
</style>



// WEBPACK FOOTER //
// src/componentsline/GysCooPeRate.vue